import { render, staticRenderFns } from "./externalDynamicDataPage.vue?vue&type=template&id=8b2c4f16&"
import script from "./externalDynamicDataPage.vue?vue&type=script&lang=js&"
export * from "./externalDynamicDataPage.vue?vue&type=script&lang=js&"
import style0 from "./externalDynamicDataPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports